// extracted by mini-css-extract-plugin
module.exports = {"menuComponent":"filterInput_menuComponent__1MLnx","iconColor":"filterInput_iconColor__2P7Ty"};